import { AxiosInstance } from '../../helpers/AxiosInstance';
import Config from '../../config';

const GetAccessToken = (data: { shop: string, code: string }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/shopify/token`, data)
}

const GetAllScriptTags = (data: { shop: string, access_token: string }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/shopify/all/scripts`, data)
}

const AddLiveChatScript = (data: { shop: string, script: string, access_token: string }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/shopify/script`, data)
}

const DeleteLiveChatScript = (data: { shop: string, access_token: string }, Id: string) => {
    return AxiosInstance.delete(`${Config.FALKON_CONNECT_API}/api/v1/shopify/delete/script/${Id}`, { data: data })
}

const StoreShopifyAcessToken = (data: { shop_id: string, token: string }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/shopify/save/token`, data)

}

const RetrieveShopifyAcessToken = (shop: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/shopify/get/token/${shop}`)

}

export const ShopifyService = {
    GetAccessToken,
    GetAllScriptTags,
    AddLiveChatScript,
    DeleteLiveChatScript,
    StoreShopifyAcessToken,
    RetrieveShopifyAcessToken,
};